import {Component} from 'react'
import Loader from 'react-loader-spinner'
import Cookies from 'js-cookie'

import {AiFillStar} from 'react-icons/ai'
import {BiMap} from 'react-icons/bi'
import {FaSuitcase} from 'react-icons/fa'
import {GrMapLocation} from 'react-icons/gr'
import Header from '../Header'
import SimilarJobItem from '../SimilarJobItem'
import './index.css'

const apiStatus = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  progress: 'PROGRESS',
  failure: 'FAILURE',
  noJob: 'NO-JOB',
}

class JobItemDetails extends Component {
  state = {apiStatusView: apiStatus.initial, jobDetailsData: {}}

  componentDidMount() {
    this.getJobDetails()
  }

  getLifeCompany = data => ({
    description: data.description,
    imageUrl: data.image_url,
  })

  getSkillData = data => ({
    name: data.name,
    imageUrl: data.image_url,
  })

  getFormattedData = data => ({
    companyLogoUrl: data.company_logo_url,
    companyWebsiteUrl: data.company_website_url,
    employmentType: data.employment_type,
    id: data.id,
    jobDescription: data.job_description,
    location: data.location,
    packagePerAnnum: data.package_per_annum,
    rating: data.rating,
    title: data.title,
    lifeAtCompany: this.getLifeCompany(data.life_at_company),
    skills: data.skills.map(eachSkill => this.getSkillData(eachSkill)),
  })

  getSimilarData = data => ({
    companyLogoUrl: data.company_logo_url,
    employmentType: data.employment_type,
    id: data.id,
    jobDescription: data.job_description,
    location: data.location,
    packagePerAnnum: data.package_per_annum,
    rating: data.rating,
    title: data.title,
  })

  getJobDetails = async () => {
    this.setState({apiStatusView: apiStatus.progress})
    const jwtToken = Cookies.get('jwt_token')
    const {match} = this.props
    const {params} = match
    const {id} = params
    const apiUrl = `https://apis.ccbp.in/jobs/${id}`
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(apiUrl, options)
    if (response.ok === true) {
      const data = await response.json()

      const updatedData = {
        jobDetails: this.getFormattedData(data.job_details),
        similarJobs: data.similar_jobs.map(eachData =>
          this.getSimilarData(eachData),
        ),
      }
      this.setState({
        jobDetailsData: updatedData,
        apiStatusView: apiStatus.success,
      })
    } else {
      this.setState({apiStatusView: apiStatus.failure})
    }
  }

  renderLoadingView = () => (
    <div className="loader-container" testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  onClickRetryButton = () => {
    this.getJobDetails()
  }

  renderFailureView = () => (
    <div className="failure-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png "
        alt="failure view"
        className="failure-job-img-1"
      />
      <h1 className="job-head">Oops Something Went Wrong</h1>
      <p className="job-para">
        we cannot seem to find the page you are looking for.
      </p>
      <button
        type="button"
        className="retry-button"
        onClick={this.onClickRetryButton}
      >
        Retry
      </button>
    </div>
  )

  renderSuccessView = () => {
    const {jobDetailsData} = this.state
    const {jobDetails, similarJobs} = jobDetailsData
    const {
      companyLogoUrl,
      title,
      rating,
      location,
      employmentType,
      packagePerAnnum,
      jobDescription,
      companyWebsiteUrl,
      skills,
      lifeAtCompany,
    } = jobDetails
    console.log(lifeAtCompany)
    return (
      <>
        <div className="job-item-container">
          <div className="job-icon-container">
            <img
              src={companyLogoUrl}
              alt="company logo"
              className="company-logo"
            />
            <div>
              <p className="job-title">{title}</p>
              <span className="star-container">
                <AiFillStar color="#fbbf24" size="20" />
                <p className="rating-para">{rating}</p>
              </span>
            </div>
          </div>
          <div className="package-container">
            <div className="locate-job-container">
              <div className="locate-container">
                <BiMap color="#ffffff" size="20" />
                <p className="job-locate-para">{location}</p>
              </div>

              <div className="job-type-container">
                <FaSuitcase color="#ffffff" size="20" />
                <p className="job-type-para">{employmentType}</p>
              </div>
            </div>
            <h1 className="package-head">{packagePerAnnum}</h1>
          </div>
          <hr className="job-hr-line" />
          <div className="visit-container">
            <h1 className="description-head">Description</h1>
            <div className="map">
              <a href={companyWebsiteUrl} className="map">
                Visit
              </a>
              <GrMapLocation size="20" color="#ffffff" />
            </div>
          </div>
          <p className="description-para">{jobDescription}</p>
          <h1 className="skill-head">Skills</h1>
          <div className="skill-main-container">
            {skills.map(eachSkill => (
              <li className="skill-container" key={eachSkill.name}>
                <img
                  src={eachSkill.imageUrl}
                  alt={eachSkill.name}
                  className="skill-img"
                />
                <p className="skill-name">{eachSkill.name}</p>
              </li>
            ))}
          </div>
          <h1 className="life-head">Life at Company</h1>
          <div className="life-company-container">
            <p className="life-para">{lifeAtCompany.description}</p>
            <img
              src={lifeAtCompany.imageUrl}
              alt="life-at-company"
              className="life-img"
            />
          </div>
        </div>
        <h1 className="similar-head">Similar Jobs</h1>
        <ul className="similar-main-container">
          {similarJobs.map(eachSimilar => (
            <SimilarJobItem key={eachSimilar.id} eachSimilar={eachSimilar} />
          ))}
        </ul>
      </>
    )
  }

  renderApiStatus = () => {
    const {apiStatusView} = this.state

    switch (apiStatusView) {
      case apiStatus.progress:
        return this.renderLoadingView()

      case apiStatus.failure:
        return this.renderFailureView()
      case apiStatus.success:
        return this.renderSuccessView()
      case apiStatus.noJob:
        return this.renderNoJobFound()

      default:
        return null
    }
  }

  render() {
    return (
      <div className="job-item-details">
        <Header />
        <div className="render-api-data">{this.renderApiStatus()}</div>
      </div>
    )
  }
}

export default JobItemDetails
